import {MonthlyLimits} from "./monthly-limits";

export default MonthlyLimits